import escapeRegExp from 'lodash/escapeRegExp';

function alphaNoSpaceValidator({ configs, input, msgs }) {
  const allowChars = configs.allow ? configs.allow.replace('&comma', ',').split(';').join('') : '';
  const disallowChars = configs.disallow ? configs.disallow.replace('&comma', ',').split(';') : [];
  const allowSpace = configs.ALLOW_SPACE_IN_FIRST_NAME === 'true';
  const regExpString = allowSpace
    ? `^[a-zA-Z-'’\\s${escapeRegExp(allowChars).replace('-', '\\-')}]+$`
    : `^[a-zA-Z-'’${escapeRegExp(allowChars).replace('-', '\\-')}]+$`;
  const rule = new RegExp(regExpString);

  for (let i = 0; i < disallowChars.length; i += 1) {
    if (input.includes(disallowChars[i])) {
      return (
        msgs.disallow.replace('%s', disallowChars.join(' ')) ||
        'The following special characters are not allowed in this field: %s'.replace(
          '%s',
          disallowChars.join(' '),
        )
      );
    }
  }

  if (!rule.test(input)) {
    if (allowChars.length > 0 && msgs.allow) {
      return msgs.allow
        ? msgs.allow.replace('%s', allowChars)
        : 'The following special characters are allowed in this field: %s'.replace(
            '%s',
            allowChars,
          );
    }
    if (!allowSpace) {
      if (msgs && msgs.alphanospace) {
        return msgs.alphanospace;
      }
      return 'Numbers, special characters, and blank spaces are not allowed in this field.';
    }
    if (msgs && msgs.alpha) {
      return msgs.alpha;
    }
    return 'Numbers and special characters are not allowed in this field.';
  }

  return null;
}

export default alphaNoSpaceValidator;
